import React, {
  DetailedHTMLProps,
  FunctionComponent,
  ImgHTMLAttributes,
} from 'react'

import styled from 'styled-components/macro'
import { TestIds } from '../../../Utils/testIds'

import { ReactComponent as AnalyzeNavSVG } from '../Basic/icons_analyze.svg'
import AnalyzeNavPath from '../Basic/icons_analyze.svg'
import { ReactComponent as JourneyNavSVG } from '../Basic/icons_journey.svg'
import JourneyNavPath from '../Basic/icons_journey.svg'
import { ReactComponent as DashboardNavSVG } from '../Basic/icons_dashboard.svg'
import DashboardNavPath from '../Basic/icons_dashboard.svg'
import { ReactComponent as RequestsNavSVG } from '../Basic/icons_requests.svg'
import RequestsNavPath from '../Basic/icons_requests.svg'
import { ReactComponent as UsersNavSVG } from '../Basic/icons_users.svg'
import UsersNavPath from '../Basic/icons_users.svg'
import { ReactComponent as ServicesNavSVG } from '../Basic/icons_services.svg'
import ServicesNavPath from '../Basic/icons_services.svg'
import { ReactComponent as ReportScanNavSVG } from '../Basic/icons_report_scan.svg'
import ReportScanNavPath from '../Basic/icons_report_scan.svg'
import { ReactComponent as PoliciesNavSVG } from '../Basic/icons_policies.svg'
import PoliciesNavPath from '../Basic/icons_policies.svg'
import { ReactComponent as CompanyInfoNavSVG } from '../Basic/icons_company_info.svg'
import CompanyInfoNavPath from '../Basic/icons_company_info.svg'
import { ReactComponent as ActivitiesNavIconSVG } from '../Basic/icons_activities.svg'
import ActivitiesNavPath from '../Basic/icons_activities.svg'
import { ReactComponent as RiskRegisterNavSVG } from '../Basic/icons_warning_gear.svg'
import RiskRegisterNavPath from '../Basic/icons_warning_gear.svg'
import { ReactComponent as ControlsNavSVG } from '../Basic/icons_controls.svg'
import ControlsNavPath from '../Basic/icons_controls.svg'
import { ReactComponent as HomeNavSVG } from '../Basic/icons_home.svg'
import HomeNavPath from '../Basic/icons_home.svg'
import { ReactComponent as HomeNewNavSVG } from '../Basic/icons_home_new.svg'
import HomeNewNavPath from '../Basic/icons_home_new.svg'
import { ReactComponent as AuditNavSVG } from '../Basic/icons_audit.svg'
import AuditNavPath from '../Basic/icons_audit.svg'
import { ReactComponent as SettingsNavSVG } from '../Basic/icons_settings.svg'
import SettingsNavPath from '../Basic/icons_settings.svg'
import { ReactComponent as EroNavSVG } from '../Basic/icons_ero.svg'
import EroNavPath from '../Basic/icons_ero.svg'
import { ReactComponent as CustomerTrustNavSVG } from '../Basic/icons_customer_trust.svg'
import CustomerTrustNavPath from '../Basic/icons_customer_trust.svg'
import { ReactComponent as PackageNavSVG } from '../assets/package-icon.svg'
import PackageNavPath from '../assets/package-icon.svg'
import { ReactComponent as NavIconsAccountsSVG } from './icons-accounts.svg'
import NavIconsAccountsPath from './icons-accounts.svg'
import { ReactComponent as NavIconsActivityLogSVG } from './icons-activity-log.svg'
import NavIconsActivityLogPath from './icons-activity-log.svg'
import { ReactComponent as NavIconsAiUsageSVG } from './icons-ai-usage.svg'
import NavIconsAiUsagePath from './icons-ai-usage.svg'
import { ReactComponent as NavIconsAuditsSVG } from './icons-audits.svg'
import NavIconsAuditsPath from './icons-audits.svg'
import { ReactComponent as NavIconsCompanyInfoSVG } from './icons-company-info.svg'
import NavIconsCompanyInfoPath from './icons-company-info.svg'
import { ReactComponent as NavIconsControlsSVG } from './icons-controls.svg'
import NavIconsControlsPath from './icons-controls.svg'
import { ReactComponent as NavIconsDashboardSVG } from './icons-dashboard.svg'
import NavIconsDashboardPath from './icons-dashboard.svg'
import { ReactComponent as NavIconsDocumentManagementSVG } from './icons-document-management.svg'
import NavIconsDocumentManagementPath from './icons-document-management.svg'
import { ReactComponent as NavIconsEvidencesSVG } from './icons-evidences.svg'
import NavIconsEvidencesPath from './icons-evidences.svg'
import { ReactComponent as NavIconsExamineTestSVG } from './icons-examine-test.svg'
import NavIconsExamineTestPath from './icons-examine-test.svg'
import { ReactComponent as NavIconsGrcPlatformsSVG } from './icons-grc-platforms.svg'
import NavIconsGrcPlatformsPath from './icons-grc-platforms.svg'
import { ReactComponent as NavIconsGrcQuestionsSVG } from './icons-grc-questions.svg'
import NavIconsGrcQuestionsPath from './icons-grc-questions.svg'
import { ReactComponent as NavIconsHelpSVG } from './icons-help.svg'
import NavIconsHelpPath from './icons-help.svg'
import { ReactComponent as NavIconsIndexingSVG } from './icons-indexing.svg'
import NavIconsIndexingPath from './icons-indexing.svg'
import { ReactComponent as NavIconsIntegrationListSVG } from './icons-integration-list.svg'
import NavIconsIntegrationListPath from './icons-integration-list.svg'
import { ReactComponent as NavIconsManageDocumentsSVG } from './icons-manage-documents.svg'
import NavIconsManageDocumentsPath from './icons-manage-documents.svg'
import { ReactComponent as NavIconsPoliciesSVG } from './icons-policies.svg'
import NavIconsPoliciesPath from './icons-policies.svg'
import { ReactComponent as NavIconsReceptorsSVG } from './icons-receptors.svg'
import NavIconsReceptorsPath from './icons-receptors.svg'
import { ReactComponent as NavIconsReportsSVG } from './icons-reports.svg'
import NavIconsReportsPath from './icons-reports.svg'
import { ReactComponent as NavIconsRiskRegisterSVG } from './icons-risk-register.svg'
import NavIconsRiskRegisterPath from './icons-risk-register.svg'
import { ReactComponent as NavIconsRoadmapSVG } from './icons-roadmap.svg'
import NavIconsRoadmapPath from './icons-roadmap.svg'
import { ReactComponent as NavIconsSchedulingSVG } from './icons-scheduling.svg'
import NavIconsSchedulingPath from './icons-scheduling.svg'
import { ReactComponent as NavIconsScopeSVG } from './icons-scope.svg'
import NavIconsScopePath from './icons-scope.svg'
import { ReactComponent as NavIconsServicesSVG } from './icons-services.svg'
import NavIconsServicesPath from './icons-services.svg'
import { ReactComponent as NavIconsSoc2ReportSVG } from './icons-soc2-report.svg'
import NavIconsSoc2ReportPath from './icons-soc2-report.svg'
import { ReactComponent as NavIconsSwitchAccountSVG } from './icons-switch-account.svg'
import NavIconsSwitchAccountPath from './icons-switch-account.svg'
import { ReactComponent as NavIconsTrustPortalSVG } from './icons-trust-portal.svg'
import NavIconsTrustPortalPath from './icons-trust-portal.svg'
import { ReactComponent as NavIconsUsersSVG } from './icons-users.svg'
import NavIconsUsersPath from './icons-users.svg'
import { ReactComponent as NavIconsVendorManagementSVG } from './icons-vendor-management.svg'
import NavIconsVendorManagementPath from './icons-vendor-management.svg'
import { ReactComponent as NavIconsWorkflowManagementSVG } from './icons-workflow-management.svg'
import NavIconsWorkflowManagementPath from './icons-workflow-management.svg'
import { ReactComponent as NavIconsPromptOverridesSVG } from './icons-prompt.svg'
import { ReactComponent as NavIconsAccessManagementSVG } from './icons-access-management.svg'
import { ReactComponent as NavIconsContentManagementSVG } from './icons-content-management.svg'
import { ReactComponent as NavIconsControlTestSVG } from './icons-control-test.svg'
import { ReactComponent as NavIconsRequestsSVG } from './icons-requests.svg'
import { ReactComponent as NavIconsFrameworksSVG } from './icons-frameworks.svg'

const StyledImg = styled.img`
  height: 24px;
  width: 24px;
`

const ActivitiesNavImg: FunctionComponent<
  DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>
> = () => <StyledImg src={ActivitiesNavPath} />

const AnalyzeNavImg: FunctionComponent<
  DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>
> = () => <StyledImg src={AnalyzeNavPath} />

const ControlsNavImg: FunctionComponent<
  DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>
> = () => <StyledImg src={ControlsNavPath} />

const DashboardNavImg: FunctionComponent<
  DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>
> = () => <StyledImg src={DashboardNavPath} data-testid={TestIds.SVG_ICON} />

const JourneyNavImg: FunctionComponent<
  DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>
> = () => <StyledImg src={JourneyNavPath} />

const RequestsNavImg: FunctionComponent<
  DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>
> = () => <StyledImg src={RequestsNavPath} />

// [AP-5545] TODO: Rename to ContentNavImg
const PoliciesNavImg: FunctionComponent<
  DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>
> = () => <StyledImg src={PoliciesNavPath} />

const CompanyInfoNavImg: FunctionComponent<
  DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>
> = () => <StyledImg src={CompanyInfoNavPath} />

const ServicesNavImg: FunctionComponent<
  DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>
> = () => <StyledImg src={ServicesNavPath} />

const UsersNavImg: FunctionComponent<
  DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>
> = () => <StyledImg src={UsersNavPath} />

// [AP-5545] TODO: Rename to AnalyzeNavImg
const ReportScanNavImg: FunctionComponent<
  DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>
> = () => <StyledImg src={ReportScanNavPath} />

const RiskRegisterNavImg: FunctionComponent<
  DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>
> = () => <StyledImg src={RiskRegisterNavPath} />

const HomeNavImg: FunctionComponent<
  DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>
> = () => <StyledImg src={HomeNavPath} />

const AuditNavImg: FunctionComponent<
  DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>
> = () => <StyledImg src={AuditNavPath} />

const SettingsNavImg: FunctionComponent<
  DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>
> = () => <StyledImg src={SettingsNavPath} />

const EroNavImg: FunctionComponent<
  DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>
> = () => <StyledImg src={EroNavPath} />

const HomeNewNavImg: FunctionComponent<
  DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>
> = () => <StyledImg src={HomeNewNavPath} />

const CustomerTrustNavImg: FunctionComponent<
  DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>
> = () => <StyledImg src={CustomerTrustNavPath} />

const PackageNavImg: FunctionComponent<
  DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>
> = () => <StyledImg src={PackageNavPath} />

const NavIconsAccountsImg: FunctionComponent<
  DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>
> = () => <StyledImg src={NavIconsAccountsPath} />

const NavIconsActivityLogImg: FunctionComponent<
  DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>
> = () => <StyledImg src={NavIconsActivityLogPath} />

const NavIconsAiUsageImg: FunctionComponent<
  DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>
> = () => <StyledImg src={NavIconsAiUsagePath} />

const NavIconsAuditsImg: FunctionComponent<
  DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>
> = () => <StyledImg src={NavIconsAuditsPath} />

const NavIconsCompanyInfoImg: FunctionComponent<
  DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>
> = () => <StyledImg src={NavIconsCompanyInfoPath} />

const NavIconsControlsImg: FunctionComponent<
  DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>
> = () => <StyledImg src={NavIconsControlsPath} />

const NavIconsDashboardImg: FunctionComponent<
  DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>
> = () => <StyledImg src={NavIconsDashboardPath} />

const NavIconsDocumentManagementImg: FunctionComponent<
  DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>
> = () => <StyledImg src={NavIconsDocumentManagementPath} />

const NavIconsEvidencesImg: FunctionComponent<
  DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>
> = () => <StyledImg src={NavIconsEvidencesPath} />

const NavIconsExamineTestImg: FunctionComponent<
  DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>
> = () => <StyledImg src={NavIconsExamineTestPath} />

const NavIconsGrcPlatformsImg: FunctionComponent<
  DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>
> = () => <StyledImg src={NavIconsGrcPlatformsPath} />

const NavIconsGrcQuestionsImg: FunctionComponent<
  DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>
> = () => <StyledImg src={NavIconsGrcQuestionsPath} />

const NavIconsHelpImg: FunctionComponent<
  DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>
> = () => <StyledImg src={NavIconsHelpPath} />

const NavIconsIndexingImg: FunctionComponent<
  DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>
> = () => <StyledImg src={NavIconsIndexingPath} />

const NavIconsIntegrationListImg: FunctionComponent<
  DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>
> = () => <StyledImg src={NavIconsIntegrationListPath} />

const NavIconsManageDocumentsImg: FunctionComponent<
  DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>
> = () => <StyledImg src={NavIconsManageDocumentsPath} />

const NavIconsPoliciesImg: FunctionComponent<
  DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>
> = () => <StyledImg src={NavIconsPoliciesPath} />

const NavIconsReceptorsImg: FunctionComponent<
  DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>
> = () => <StyledImg src={NavIconsReceptorsPath} />

const NavIconsReportsImg: FunctionComponent<
  DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>
> = () => <StyledImg src={NavIconsReportsPath} />

const NavIconsRiskRegisterImg: FunctionComponent<
  DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>
> = () => <StyledImg src={NavIconsRiskRegisterPath} />

const NavIconsRoadmapImg: FunctionComponent<
  DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>
> = () => <StyledImg src={NavIconsRoadmapPath} />

const NavIconsSchedulingImg: FunctionComponent<
  DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>
> = () => <StyledImg src={NavIconsSchedulingPath} />

const NavIconsScopeImg: FunctionComponent<
  DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>
> = () => <StyledImg src={NavIconsScopePath} />

const NavIconsServicesImg: FunctionComponent<
  DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>
> = () => <StyledImg src={NavIconsServicesPath} />

const NavIconsSoc2ReportImg: FunctionComponent<
  DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>
> = () => <StyledImg src={NavIconsSoc2ReportPath} />

const NavIconsSwitchAccountImg: FunctionComponent<
  DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>
> = () => <StyledImg src={NavIconsSwitchAccountPath} />

const NavIconsTrustPortalImg: FunctionComponent<
  DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>
> = () => <StyledImg src={NavIconsTrustPortalPath} />

const NavIconsUsersImg: FunctionComponent<
  DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>
> = () => <StyledImg src={NavIconsUsersPath} />

const NavIconsVendorManagementImg: FunctionComponent<
  DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>
> = () => <StyledImg src={NavIconsVendorManagementPath} />

const NavIconsWorkflowManagementImg: FunctionComponent<
  DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>
> = () => <StyledImg src={NavIconsWorkflowManagementPath} />

StyledImg.defaultProps = {
  src: '',
}

const NavIcons = {
  AnalyzeNavSVG,
  AnalyzeNavImg,
  ActivitiesNavIconSVG,
  ActivitiesNavImg,
  ControlsNavSVG,
  ControlsNavImg,
  DashboardNavSVG,
  DashboardNavImg,
  JourneyNavSVG,
  JourneyNavImg,
  RequestsNavSVG,
  RequestsNavImg,
  PoliciesNavSVG,
  PoliciesNavImg,
  ServicesNavSVG,
  ServicesNavImg,
  UsersNavSVG,
  UsersNavImg,
  CompanyInfoNavSVG,
  CompanyInfoNavImg,
  ReportScanNavSVG,
  ReportScanNavImg,
  RiskRegisterNavSVG,
  RiskRegisterNavImg,
  HomeNavSVG,
  HomeNavImg,
  HomeNewNavSVG,
  HomeNewNavImg,
  AuditNavSVG,
  AuditNavImg,
  SettingsNavSVG,
  SettingsNavImg,
  EroNavSVG,
  EroNavImg,
  CustomerTrustNavImg,
  CustomerTrustNavSVG,
  PackageNavSVG,
  NavIconsAccountsSVG,
  NavIconsAccountsImg,
  NavIconsActivityLogSVG,
  NavIconsActivityLogImg,
  NavIconsAiUsageSVG,
  NavIconsAiUsageImg,
  NavIconsAuditsSVG,
  NavIconsAuditsImg,
  NavIconsCompanyInfoSVG,
  NavIconsCompanyInfoImg,
  NavIconsControlsSVG,
  NavIconsControlsImg,
  NavIconsDashboardSVG,
  NavIconsDashboardImg,
  NavIconsDocumentManagementSVG,
  NavIconsDocumentManagementImg,
  NavIconsEvidencesSVG,
  NavIconsEvidencesImg,
  NavIconsExamineTestSVG,
  NavIconsExamineTestImg,
  NavIconsGrcPlatformsSVG,
  NavIconsGrcPlatformsImg,
  NavIconsGrcQuestionsSVG,
  NavIconsGrcQuestionsImg,
  NavIconsHelpSVG,
  NavIconsHelpImg,
  NavIconsIndexingSVG,
  NavIconsIndexingImg,
  NavIconsIntegrationListSVG,
  NavIconsIntegrationListImg,
  NavIconsManageDocumentsSVG,
  NavIconsManageDocumentsImg,
  NavIconsPoliciesSVG,
  NavIconsPoliciesImg,
  NavIconsReceptorsSVG,
  NavIconsReceptorsImg,
  NavIconsReportsSVG,
  NavIconsReportsImg,
  NavIconsRiskRegisterSVG,
  NavIconsRiskRegisterImg,
  NavIconsRoadmapSVG,
  NavIconsRoadmapImg,
  NavIconsSchedulingSVG,
  NavIconsSchedulingImg,
  NavIconsScopeSVG,
  NavIconsScopeImg,
  NavIconsServicesSVG,
  NavIconsServicesImg,
  NavIconsSoc2ReportSVG,
  NavIconsSoc2ReportImg,
  NavIconsSwitchAccountSVG,
  NavIconsSwitchAccountImg,
  NavIconsTrustPortalSVG,
  NavIconsTrustPortalImg,
  NavIconsUsersSVG,
  NavIconsUsersImg,
  NavIconsVendorManagementSVG,
  NavIconsVendorManagementImg,
  NavIconsWorkflowManagementSVG,
  NavIconsWorkflowManagementImg,
  NavIconsPromptOverridesSVG,
  NavIconsAccessManagementSVG,
  NavIconsContentManagementSVG,
  NavIconsControlTestSVG,
  NavIconsRequestsSVG,
  NavIconsFrameworksSVG,
}

export default NavIcons

export {
  AnalyzeNavSVG,
  AnalyzeNavImg,
  ActivitiesNavIconSVG,
  ActivitiesNavImg,
  ControlsNavSVG,
  ControlsNavImg,
  JourneyNavSVG,
  JourneyNavImg,
  RequestsNavSVG,
  RequestsNavImg,
  PoliciesNavSVG,
  PoliciesNavImg,
  ServicesNavSVG,
  ServicesNavImg,
  UsersNavSVG,
  UsersNavImg,
  DashboardNavSVG,
  DashboardNavImg,
  CompanyInfoNavSVG,
  CompanyInfoNavImg,
  ReportScanNavSVG,
  ReportScanNavImg,
  RiskRegisterNavSVG,
  RiskRegisterNavImg,
  HomeNavSVG,
  HomeNavImg,
  HomeNewNavSVG,
  HomeNewNavImg,
  AuditNavSVG,
  AuditNavImg,
  SettingsNavSVG,
  SettingsNavImg,
  EroNavSVG,
  EroNavImg,
  CustomerTrustNavImg,
  CustomerTrustNavSVG,
  PackageNavImg,
  PackageNavSVG,
  NavIconsAccountsSVG,
  NavIconsAccountsImg,
  NavIconsActivityLogSVG,
  NavIconsActivityLogImg,
  NavIconsAiUsageSVG,
  NavIconsAiUsageImg,
  NavIconsAuditsSVG,
  NavIconsAuditsImg,
  NavIconsCompanyInfoSVG,
  NavIconsCompanyInfoImg,
  NavIconsControlsSVG,
  NavIconsControlsImg,
  NavIconsDashboardSVG,
  NavIconsDashboardImg,
  NavIconsDocumentManagementSVG,
  NavIconsDocumentManagementImg,
  NavIconsEvidencesSVG,
  NavIconsEvidencesImg,
  NavIconsExamineTestSVG,
  NavIconsExamineTestImg,
  NavIconsGrcPlatformsSVG,
  NavIconsGrcPlatformsImg,
  NavIconsGrcQuestionsSVG,
  NavIconsGrcQuestionsImg,
  NavIconsHelpSVG,
  NavIconsHelpImg,
  NavIconsIndexingSVG,
  NavIconsIndexingImg,
  NavIconsIntegrationListSVG,
  NavIconsIntegrationListImg,
  NavIconsManageDocumentsSVG,
  NavIconsManageDocumentsImg,
  NavIconsPoliciesSVG,
  NavIconsPoliciesImg,
  NavIconsReceptorsSVG,
  NavIconsReceptorsImg,
  NavIconsReportsSVG,
  NavIconsReportsImg,
  NavIconsRiskRegisterSVG,
  NavIconsRiskRegisterImg,
  NavIconsRoadmapSVG,
  NavIconsRoadmapImg,
  NavIconsSchedulingSVG,
  NavIconsSchedulingImg,
  NavIconsScopeSVG,
  NavIconsScopeImg,
  NavIconsServicesSVG,
  NavIconsServicesImg,
  NavIconsSoc2ReportSVG,
  NavIconsSoc2ReportImg,
  NavIconsSwitchAccountSVG,
  NavIconsSwitchAccountImg,
  NavIconsTrustPortalSVG,
  NavIconsTrustPortalImg,
  NavIconsUsersSVG,
  NavIconsUsersImg,
  NavIconsVendorManagementSVG,
  NavIconsVendorManagementImg,
  NavIconsWorkflowManagementSVG,
  NavIconsWorkflowManagementImg,
  NavIconsControlTestSVG,
  NavIconsFrameworksSVG,
}
